import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.dev';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  
  constructor(public router: Router) { }
  loginRoute(){
    let id =localStorage.getItem('id');
    // console.log(id);
    window.location.href = environment.AngularFrontUrl + '/enrollment-form?id='+id;
   
  }
  ngOnInit(): void {
    
  }

}

